import $ from 'jquery';
import {accountLogin} from '../queries';
import {Cookie} from '../utilities';
import Popup from '../utilities/Popup';
import onDocumentReady from "../utilities/onDocumentReady";

$('.js-form-login').on('ui-submit', async function () {
    const response = await accountLogin($(this).serializeJSON());
    if (!response.isSuccess) {
        $(this).trigger('error', response.error);
        return;
    }

    if (location.pathname === '/basket/') {
        location.href = '/order/';
    }

    window.ym(56412904, 'reachGoal', 'user-login');
    window.ym(56412904, 'reachGoal', 'user-authorize');
    setTimeout(() => {
        if (response.isRedirect) {
            Cookie.set('USER_AUTH', true, false);
            window.location.href = response.url.url;
            return;
        }
        Cookie.set('USER_AUTH', true, false);
        window.location.reload();
    }, 300);

});

onDocumentReady(() => {
    if (Cookie.get('USER_AUTH') === true) {
        if (location.pathname === '/order/') {
            $(`.ui-modal[data-name="order-login-message"]`).trigger('show');
        }
        Cookie.set('USER_AUTH', false, false);
    }
});

$('input[name="login_type"]').change(function () {
    if ($(this).is(':checked')) {
        $('.js-form-login .ui-input--login').show().find('input').prop('required', true);
        $('.js-form-login .ui-input--phone').hide()
            .find('input')
            .prop('required', false)[0]
            .setCustomValidity('');
    } else {
        $('.js-form-login .ui-input--login').hide().find('input').prop('required', false).val('');
        $('.js-form-login .ui-input--phone').show().find('input').prop('required', true).change();
    }
});


